import { SUBSCRIPTION } from '../actions/subscription';
import product from '../sagas/product';

const initialState = {
  categoryLoaded: false,
  categoryLoading: false,
  categories:[],
  products:[],
  productLoading:false,
  productLoaded:false,

};

export default (state = initialState, { type, ...action }) => {
  switch (type) {
    case SUBSCRIPTION.SUBSCRIPTION_LOAD_CATEGORIES:
      return Object.assign({}, state, { categoryLoaded: false }, { categoryLoading: true });
    case SUBSCRIPTION.SUBSCRIPTION_LOAD_CATEGORIES_DONE: {
      return {
        ...state,
        categories: [...action.categories],
        categoryLoaded: true,
        categoryLoading: false,
      };
    }
    case SUBSCRIPTION.SUBSCRIPTION_LOAD_CATEGORIES_FAIL:
      return {
        ...state,
        categoryLoaded: false,
        categoryLoading: false,
      };
   
    case SUBSCRIPTION.SUBSCRIPTION_LOAD_PRODUCTS:
      return Object.assign({}, state, { productLoaded: false }, { productLoading: true });
    case SUBSCRIPTION.SUBSCRIPTION_LOAD_PRODUCTS_DONE: {
      return {
        ...state,
        products: [...action.products],
        productLoaded: true,
        productLoading: false,
      };
    }
    case SUBSCRIPTION.SUBSCRIPTION_LOAD_PRODUCTS_FAIL:
      return {
        ...state,
        productLoaded: false,
        productLoading: false,
      };
      
    default:
      return state;
  }
};
